export const dryToppingsData = [
  {
    name: 'Fruity Pebbles',
  },
  {
    name: 'Cinn Toast Crunch',
  },
  {
    name: 'Captain Crunch',
  },
  {
    name: 'Marshmallow',
  },
  {
    name: 'Cotton Candy Fizz',
  },
  {
    name: 'Gummy Worms',
  },
  {
    name: 'Mini Gummy Bears',
  },
  {
    name: 'Nerds',
  },
  {
    name: 'Skittles',
  },
  {
    name: 'Sugar Cone',
  },
  {
    name: 'Oreo',
  },
  {
    name: 'Chocolate Sprinkles',
  },
  {
    name: 'Rainbow Sprinkles',
  },
  {
    name: 'Chocolate Rocks',
  },
  {
    name: 'Mini M&Ms',
  },
  {
    name: 'Granola',
  },
  {
    name: 'Andes Candies',
  },
  {
    name: 'Snickers',
  },
  {
    name: 'KitKat',
  },
  {
    name: 'Reeses Pieces',
  },
  {
    name: 'Heath',
  },
  {
    name: 'Chips Ahoy',
  },
  {
    name: 'Butter finger',
  },
  {
    name: 'Granulated Peanuts',
  },
  {
    name: 'Almonds',
  },
  {
    name: 'Krunch Kote',
  },
  {
    name: 'Mini Chocolate Chips',
  },
  {
    name: 'Peanut Butter Chips',
  },
  {
    name: 'Yogurt Chips',
  },
  {
    name: 'Toasted Coconut',
  },
  {
    name: 'Shredded Coconut',
  },
];

export default {
  dryToppingsData,
};
